import { HTTP_STATUS, PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { NotificationItemRow } from './NotificationItemRow';
import { NotificationRowError } from './NotificationRowError';
import { NotificationRowSkeleton } from './NotificationRowSkeleton';
import { APIError } from '~/api/APICommunicator';
import useLead from '~/features/leadDetails/hooks/useLead';
import { getApplicantPreviewName } from '~/features/notifications/utils/getApplicantPreviewName';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';

type Props = {
    loanRequestId: string;
    processedAt: number;
    onNavigate?: () => void;
};

export const ProcessedActiveUserSetRow: React.FC<Props> = ({ loanRequestId, onNavigate, processedAt }) => {
    const { t } = useTranslation();
    const lead = useLead(loanRequestId);

    if (lead.isLoading) return <NotificationRowSkeleton />;
    // lead no longer readable (403): nothing to link to
    if (lead.error instanceof APIError && lead.error.status === HTTP_STATUS.FORBIDDEN) return null;
    if (lead.isError) return <NotificationRowError />;
    if (!lead.data?.antragsteller1) return null;

    return (
        <NotificationItemRow
            previewName={getApplicantPreviewName(lead.data.antragsteller1.personendaten)}
            previewDetail={t('TOP_HEADER.NOTIFICATIONS.ACTIVE_USER_SET')}
            timestamp={processedAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.ACTIVE_USER_SET, loanRequestId)}
            onNavigate={onNavigate}
        />
    );
};
